import { Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "../../Broker/SPOCTable/SpocTable.scss";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import SlidingPanel from "react-sliding-side-panel";
function SpocTable() {
  const navigate = useNavigate();
  const [spocContact, setSpocContact] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [jobTitle, setJobTitle] = React.useState("");
  const [contactEmail, setContactEmail] = React.useState("");
  const [contactMobile, setContactMobile] = React.useState("");
  const [contactNumber, setContactNumber] = React.useState("");
  const [currentEmployer, setCurrentEmployer] = React.useState("");
  const [contactOrganization, setContactOrganization] = React.useState("");
  const [contactDepartment, setContactDepartment] = React.useState("");

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const [spocData, setSpocData] = React.useState([
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
      actionBtnOne: "images/delete_icon.svg",
    },
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
      actionBtnOne: "images/delete_icon.svg",
    },
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
      actionBtnOne: "images/delete_icon.svg",
    },
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
      actionBtnOne: "images/delete_icon.svg",
    },
  ]);
  const spoc_contact_data = [
    { key: "EV0065VikasSaini", value: "EV0065 Vikas Saini" },
    { key: "EV0016KartikeKakkar", value: "EV0016 Kartike Kakkar" },
  ];
  const contact_department_data = [
    { key: "Engineering", value: "Engineering" },
    { key: "IT", value: "IT" },
    { key: "Human Resource", value: "Human Resource" },
    { key: "Business Development", value: "Business Development" },
    { key: "Designing", value: "Designing" },
    { key: "Management", value: "Management" },
  ];
  const current_employer_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  const job_title_data = [
    {
      key: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { key: "Hr", value: "Hr" },
    { Key: "QA Engineer", value: "QA Engineer" },
  ];
  const contact_organization_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  return (
    <>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <div className="table">
            <div className="spoc-table">
              <ul className="heading">
                <li>
                  Name
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Organization
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Mobile
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Email
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Office Phone
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Office Email
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Current Job Title
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Department
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Current Employer
                  <button className="sorting-btn"></button>
                </li>
                <li>
                  Actions
                  <button className="sorting-btn mr-0"></button>
                </li>
              </ul>

              {spocData.map((data, index) => (
                <ul className="subheading">
                  <li>{data.Name}</li>
                  <li>{data.org}</li>
                  <li>{data.mobile}</li>
                  <li>{data.emails}</li>
                  <li>{data.officephone}</li>
                  <li>{data.officeemail}</li>
                  <li>{data.curruntjobtitle}</li>
                  <li>{data.Department}</li>
                  <li>{data.curruntemployer}</li>
                  <li>
                    <Link className="edit_address_link">
                      <img src={data.actionBtn} alt="" className="mr-3" />
                      <img src={data.actionBtnOne} alt="" />
                    </Link>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default SpocTable;
